import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EDrawingActionType } from './types';

export const startDrawing = actionGenerator<EDrawingActionType.DrawingStarted>(EDrawingActionType.DrawingStarted);
